import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/config";
import emailjs from "@emailjs/browser";

import SectionContainer from "../common/SectionContainer";


function AuditForm() {
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    website: "",
    industry: "",
    challenge: "",
    goal: "",
    name: "",
    email: "",
    company: ""
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const totalSteps = 5;

  const updateField = (field, value) => {
    setFormData({
      ...formData,
      [field]: value
    });
  };

  const nextStep = () => {
    setStep((prev) => prev + 1);
  };

  const previousStep = () => {
    setStep((prev) => prev - 1);
  };

  const progress =
    (step / totalSteps) * 100;

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);

      await addDoc(
        collection(db, "contacts"),
        {
          type: "audit",

          website:
            formData.website,

          industry:
            formData.industry,

          challenge:
            formData.challenge,

          goal:
            formData.goal,

          name:
            formData.name,

          email:
            formData.email,

          company:
            formData.company,

          status: "new",

          timestamp:
            serverTimestamp()
        }
      );

      await emailjs.send(
        process.env
          .REACT_APP_EMAILJS_SERVICE_ID,

        process.env
          .REACT_APP_EMAILJS_ADMIN_TEMPLATE_ID,

        {
          lead_type:
            "Growth Audit",

          user_name:
            formData.name,

          website:
            formData.website,

          company:
            formData.company,

          user_email:
            formData.email
        },

        process.env
          .REACT_APP_EMAILJS_PUBLIC_KEY
      );

      await emailjs.send(
        process.env
          .REACT_APP_EMAILJS_SERVICE_ID,

        process.env
          .REACT_APP_EMAILJS_USER_TEMPLATE_ID,

        {
          lead_type:
            "Growth Audit",

          user_name:
            formData.name,

          user_email:
            formData.email,

          company:
            formData.company,

          website:
            formData.website,

          industry:
            formData.industry,

          challenge:
            formData.challenge,

          goal:
            formData.goal
        },

        process.env
          .REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setSubmitted(true);
    } catch (err) {
      console.error(err);

      setError(
        "Something went wrong. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };
    if (submitted) {
    return (
      <SectionContainer background="#fff">
        <div
          style={{
            maxWidth: "850px",
            margin: "0 auto"
          }}
        >
          <motion.div
            initial={{
              opacity: 0,
              y: 30
            }}
            animate={{
              opacity: 1,
              y: 0
            }}
            style={{
              background: "#fff",
              border:
                "1px solid rgba(0,33,71,.08)",
              borderRadius: "32px",
              padding: "70px",
              textAlign: "center",
              boxShadow:
                "0 20px 80px rgba(0,33,71,.08)"
            }}
          >
            <div
              style={{
                fontSize: "4rem",
                marginBottom: "24px"
              }}
            >
              🚀
            </div>

            <h2
              style={{
                color: "#002147",
                fontWeight: 700
              }}
            >
              Audit Request Received
            </h2>

            <p
              style={{
                color: "#6e6e73",
                maxWidth: "650px",
                margin: "24px auto",
                lineHeight: 1.8
              }}
            >
              We've received your
              request and sent a
              confirmation email.

              Our team will review
              your website and
              prepare actionable
              growth recommendations.
            </p>
          </motion.div>
        </div>
      </SectionContainer>
    );
  }

  return (
    <SectionContainer background="#fff">
      <div
        style={{
          maxWidth: "850px",
          margin: "0 auto"
        }}
      >
        <div
          style={{
            marginBottom: "30px"
          }}
        >
          <div
            style={{
              height: "8px",
              background: "#e5e7eb",
              borderRadius: "999px"
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                height: "100%",
                borderRadius: "999px",
                background:
                  "linear-gradient(90deg,#21b573,#002147)",
                transition:
                  "all .3s ease"
              }}
            />
          </div>
        </div>

        <div
          style={{
            background: "#fff",
            border:
              "1px solid rgba(0,33,71,.08)",
            borderRadius: "32px",
            padding: "56px",
            boxShadow:
              "0 20px 80px rgba(0,33,71,.08)"
          }}
        >
          {error && (
            <div
              className="alert alert-danger"
            >
              {error}
            </div>
          )}

          <AnimatePresence
            mode="wait"
          >
                      {step === 1 && (
              <motion.div
                key="website"
                initial={{
                  opacity: 0,
                  x: 40
                }}
                animate={{
                  opacity: 1,
                  x: 0
                }}
                exit={{
                  opacity: 0,
                  x: -40
                }}
              >
                <h2>
                  What's your website?
                </h2>

                <input
                  className="form-control mt-4"
                  value={
                    formData.website
                  }
                  onChange={(e) =>
                    updateField(
                      "website",
                      e.target.value
                    )
                  }
                  placeholder="https://yourwebsite.com"
                />

                <button
                  className="btn btn-success mt-4"
                  onClick={
                    nextStep
                  }
                >
                  Continue
                </button>
              </motion.div>
            )}

            {step === 2 && (
              <motion.div
                key="industry"
                initial={{
                  opacity: 0,
                  x: 40
                }}
                animate={{
                  opacity: 1,
                  x: 0
                }}
                exit={{
                  opacity: 0,
                  x: -40
                }}
              >
                <h2>
                  Which industry
                  are you in?
                </h2>

                <select
                  className="form-control mt-4"
                  value={
                    formData.industry
                  }
                  onChange={(e) =>
                    updateField(
                      "industry",
                      e.target.value
                    )
                  }
                >
                  <option>
                    Select Industry
                  </option>

                  <option>
                    Healthcare
                  </option>

                  <option>
                    Education
                  </option>

                  <option>
                    Technology
                  </option>

                  <option>
                    Real Estate
                  </option>

                  <option>
                    Ecommerce
                  </option>

                  <option>
                    Professional Services
                  </option>
                </select>

                <div className="mt-4">
                  <button
                    className="btn btn-light me-2"
                    onClick={
                      previousStep
                    }
                  >
                    Back
                  </button>

                  <button
                    className="btn btn-success"
                    onClick={
                      nextStep
                    }
                  >
                    Continue
                  </button>
                </div>
              </motion.div>
            )}

            {step === 3 && (
              <motion.div key="challenge">
                <h2>
                  What's your biggest
                  growth challenge?
                </h2>

                <textarea
                  rows="5"
                  className="form-control mt-4"
                  value={
                    formData.challenge
                  }
                  onChange={(e) =>
                    updateField(
                      "challenge",
                      e.target.value
                    )
                  }
                />

                <div className="mt-4">
                  <button
                    className="btn btn-light me-2"
                    onClick={
                      previousStep
                    }
                  >
                    Back
                  </button>

                  <button
                    className="btn btn-success"
                    onClick={
                      nextStep
                    }
                  >
                    Continue
                  </button>
                </div>
              </motion.div>
            )}

            {step === 4 && (
              <motion.div key="goal">
                <h2>
                  What's your primary goal?
                </h2>

                <textarea
                  rows="5"
                  className="form-control mt-4"
                  value={
                    formData.goal
                  }
                  onChange={(e) =>
                    updateField(
                      "goal",
                      e.target.value
                    )
                  }
                />

                <div className="mt-4">
                  <button
                    className="btn btn-light me-2"
                    onClick={
                      previousStep
                    }
                  >
                    Back
                  </button>

                  <button
                    className="btn btn-success"
                    onClick={
                      nextStep
                    }
                  >
                    Continue
                  </button>
                </div>
              </motion.div>
            )}

            {step === 5 && (
              <motion.div key="contact">
                <h2>
                  Where should we send the audit?
                </h2>

                <input
                  className="form-control mt-4"
                  placeholder="Full Name"
                  value={
                    formData.name
                  }
                  onChange={(e) =>
                    updateField(
                      "name",
                      e.target.value
                    )
                  }
                />

                <input
                  className="form-control mt-3"
                  placeholder="Business Email"
                  value={
                    formData.email
                  }
                  onChange={(e) =>
                    updateField(
                      "email",
                      e.target.value
                    )
                  }
                />

                <input
                  className="form-control mt-3"
                  placeholder="Company"
                  value={
                    formData.company
                  }
                  onChange={(e) =>
                    updateField(
                      "company",
                      e.target.value
                    )
                  }
                />

                <div className="mt-4">
                  <button
                    className="btn btn-light me-2"
                    onClick={
                      previousStep
                    }
                  >
                    Back
                  </button>

                  <button
                    className="btn btn-success"
                    disabled={
                      isSubmitting
                    }
                    onClick={
                      handleSubmit
                    }
                  >
                    {isSubmitting
                      ? "Submitting..."
                      : "Request Growth Audit"}
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </SectionContainer>
  );
}

export default AuditForm;